import React from 'react';
import { useTranslation } from 'react-i18next';
import { DialogTitle } from 'components/ui/dialog';
import { ExamDialog } from 'components/exam/ExamDialog';
import { useSaveFeedback } from '../useSaveFeedback';
import { FeedbackForm } from './FeedbackForm';

export interface FeedbackDialogProps {
  open: boolean;
  attemptId: string;
  /** Called after sending, after "Later", and on Escape or the scrim: all of them move on to the result. */
  onClose: () => void;
}

/** "Test haqida fikringiz": shown once, right after a test is handed in. Skipping it loses nothing — the result pages offer it again. */
export function FeedbackDialog({ open, attemptId, onClose }: FeedbackDialogProps) {
  const { t } = useTranslation();
  const save = useSaveFeedback(attemptId);

  return (
    <ExamDialog open={open} onClose={onClose} widthClass="max-w-[520px]" withDescription={false}>
      <DialogTitle className="mb-4 text-[22px] font-bold leading-tight tracking-[-0.02em]">
        {t('feedback.title')}
      </DialogTitle>
      <FeedbackForm
        pending={save.isPending}
        onLater={onClose}
        onSubmit={async (input) => {
          try {
            await save.mutateAsync(input);
            onClose();
          } catch {
            // The hook has already told the learner; the dialog stays open so nothing they typed is lost.
          }
        }}
      />
    </ExamDialog>
  );
}
